import { useParams } from '@/providers/RouterShim';

const PROD = [
  '92f50cd3-5d07-45e0-8e63-f1eb9a93188d',
  '1794e52e-e270-41d5-93c3-dd680629f6b6',
  '69250802-2551-45cc-ba7d-0e3f6209ec1c',
  '3d266303-abf2-4e91-9176-440daa9141a3',
  '895c5b46-54a2-47a3-82d0-5d031fd3c019',
  '8cc1c9f2-77d3-4d7b-9e5b-8cbb504ba5c8',
  '3234c55c-05a6-45c4-aff6-200d210184cb',
  '6fbf4457-4da1-444b-8ff3-4b80ed6ed782',
  '483da1e7-fe57-4737-aa38-ebf39a096809',
  '75b30e07-86e0-475d-9435-a4fd78be1a2d',
  '77e9a4ee-cd0c-4ce6-9cfa-32222ec242d3',
  '9651c91d-8aed-4c9a-8466-9bbf3326648b',
  'aaaa78f0-992c-47ec-97b0-0f9fbd21d9d7',
  '13c67420-589e-4c1c-acc8-293610415113',
  '43cd9cd6-6ac7-4804-a9e2-486669ce187a',
  '084af880-92db-47b4-a841-95a5e24b4392',
  '4b93f690-8531-4b9a-acb5-17bddea8bcbe',
  'ab72c33c-3776-45f6-b489-0d5067adc58f',
  '71db8fcb-5ff7-44ad-9c38-c8225c89e178',
  'd1009d26-d040-4e0e-9a55-35de29590cf0',
  'aa23b764-4d6b-4f8c-b8a5-eb87b26ce4ae',
  'aac15008-62c6-4691-82b8-cd2095a1e203',
  '02aad0f7-daf5-41d0-b7e9-07c792ca7ef8',
  'ff951862-cb5e-49b2-93b4-fafebd90e326',
  '9898e839-40e5-4e10-8173-7d4fef91e15b',
  '1fed0a45-c958-4800-96f7-0c1e160cb7ad',
  '6eaca07b-c545-489c-98ef-d2cad4acf1a1',
  '82411324-4d96-42b6-98ee-2b814e6cdd95',
  'aedb6896-5bec-4a02-b98a-5f36a208f91d',
  'ed4b391e-1dab-45dc-b40b-00d92affb5b9',
  'fba1be64-f16a-4f10-8d33-dba65eefa775',
  '3e37f39c-c62b-4f38-b6f6-b2562c993d08',
  'f7f4cb8f-5228-42a0-b763-5eb4461a25a0',
  '13ad3be6-13b8-425e-ba34-2a42cb32ff5a',
  'b01f8904-fa08-4b9d-b762-02cea6ccc344',
  'cada681f-6e98-41a8-bffb-42a0379681f5',
  'd5eb9a89-a161-4f90-a96a-069e7d0977cd',
  '89d67048-ef16-4b20-b193-a0c594f1a099',
  'c6ce14cb-7369-4c3d-b3e4-d5bfd6754680',
  'bd677dad-a018-404c-90d9-d9ef3462416c',
  '6e1971dd-0d48-4277-9d4d-7a972b423186',
  'f8e234ad-95ab-4344-ac06-94f498adea34',
  'ed0d873a-4336-444a-8182-f5b818560c9a',
  '5907aed3-e430-4127-b94c-3f7f21b35bc5',
  'f97be105-c450-463c-a582-6d55d879a91f',
  '86c5722d-9596-4639-967d-fd1bfec6492b',
  '8b7082fa-0383-482f-a742-a326ab21857c',
  '4c6d572e-39af-47a8-ad6a-a22ee860b0e8',
  '56ac560a-d605-4b59-89b4-f887e2cb1974',
  'fab1ae9c-4c1a-4ffc-b6c2-cf34f64b6987',
  'a4100610-1fc4-499b-8d24-fa38bf354a8b',
  '9ca5307f-e099-4e02-83e0-d18c2c686d84',
  '45d5f5f1-81ed-432e-b33a-fd0a84efbc98',
  '59c70d4b-d215-4b6c-9439-f422cb18d97d',
  '8e60fae4-065e-47ef-9c7a-8def99595d30',
  '22b3b323-8548-4fa1-a883-413995284a0d',
  'fc9f3bc9-9a73-4850-a1d5-30cd410ac7e4',
  '935bdef4-06ab-439e-bf08-fc0bdd690fe8',
  'ff7c4851-8d42-4be7-81b6-b11a18335d6a',
  '0b01507c-bee2-428a-beeb-f91bd18eb584',
  '02f65a1c-8d39-4944-922e-0c4b7cbc3ef9',
  '89e9cdf6-6613-4b15-ac6d-02e3d7358d55',
  'dd97a707-b80b-4fb8-8e63-98ecb5d0d917',
  '71da1d54-3176-423e-955c-8e40e471ee3a',
  '4552e305-ecb0-44d9-aba2-48a90098f9fc',
  '64c9a876-6ddd-44a4-b92d-6de792b94556',
  '78ac66d6-a759-4633-bcf3-3b6941ba06b0',
  'c72c9fb0-9fc0-4c23-bb4b-d19b09dbd906',
  '1d0a1784-15a4-432f-9d9d-3738a48fbe95',
  '12aa3a7d-ccab-42d0-9752-61cf7ee1d5e3',
  '2d023d94-9e23-4d58-a37e-fbd5682905ec',
  '3a020586-1048-4e08-a5ba-0a2f82ed8d61',
  'c2df0edb-141f-446c-98d6-dc9c78460a4c',
  'cd3ad9ea-02e3-4d58-a085-d129d9ac9e47',
  '099783fb-3abd-4f8c-ad5e-240ec90ea870',
  'a4eed04a-f88e-4f6a-a5c2-68d1323cb36c',
];

const TEST = [
  '03f5dfce-b529-4481-9ba6-c5f2497372fa',
  '07169a41-e43c-4036-9250-627f08f25dc4',
  '0910ad8a-7909-4a8c-8a71-c5930c7b9cb8',
  '09a7cb7e-1947-40f4-8c21-f475872c5ac7',
  '17c774b7-4579-44c2-ab9c-5a20ce8de931',
  '1bfec2d5-b3a6-4dda-9c0e-c993d55ca1b0',
  '1d3b4877-794c-4542-a1f7-3fb341ae2e22',
  '1f564916-d74a-48d2-88da-528a52ae8faf',
  '219cd488-4489-46a7-a1bc-4280ae87c799',
  '26b73706-69db-48f9-9432-53d680fa2049',
  '26de9aa0-3736-47fb-80a3-a055137f9317',
  '270bf0fb-df31-4a4a-b2a1-760704b6da10',
  '272bd4f9-c5ae-4e37-bfcb-21167ab6b178',
  '30bd1a36-7718-4093-91e8-ff0f586b9863',
  '32f1e2e7-8c22-4d41-809f-1c55e91c0bcd',
  '375614a1-eeb0-47cc-8a61-085fd399f0da',
  '416441eb-e058-4685-858a-c1a9d2918dc0',
  '4861a87d-1f7a-4078-8081-6cdeca229e1b',
  '4c0a760d-4174-4b2a-bce3-64ede537b1fc',
  '4c3e046e-2a96-402c-aa8d-90322711d59a',
  '61e4588a-3642-40fb-8a7c-c697b6a49480',
  '61fcbe56-2a07-4fd9-8850-02b070a1470c',
  '66fe865a-e09e-4dad-bce8-5ed0301da98f',
  '6e8bc57d-9142-4728-bb7e-69d5da1e97ef',
  '6ef9053c-241f-41d9-973c-95c683f0de00',
  '72a81a8d-b927-46bc-af5e-c5ec1be0c631',
  '7589082d-09a9-4ec7-8264-2b9d1c64fe84',
  '78091ea8-2fe4-488c-9559-205e5e679c73',
  '789e2530-01a2-45a3-a362-f1218afb7968',
  '7a42e6ad-7296-4f1b-85d9-da634e61a83a',
  '7e4aaec2-82c7-4d38-a92e-32a575b67e0c',
  '88f06dca-18ff-464e-a96a-ec79adf95aed',
  '8c57a6c1-0d76-4663-9e7d-d332ea0bdc9e',
  '8d1c5100-2017-48b1-a136-1ea5d6a1b9ea',
  '91683735-9812-45f7-b966-d7a7dca4a11e',
  '957f5885-4eb0-47a7-b68a-720a896cfa5a',
  '9d8a0b37-94e1-46ad-8dc0-f4375f3aaa4d',
  'ab0ead6b-d80e-4fb6-a837-286339fa1ef1',
  'af2996c0-02f8-41c4-b68c-3e2daf26542e',
  'af855b62-1949-4d55-b23c-3575de33897a',
  'b01661f2-05c0-424c-9388-a32bab9a3b01',
  'ba0f4021-2d4d-45cb-9a25-bece72781694',
  'bc388586-4f72-4c29-9f7e-546a187359d4',
  'be3a48fd-2781-44c4-b2ea-6e7b60b25b5d',
  'bf6f7869-7392-4b0d-84e1-35baa502b151',
  'c71de5ba-d8f9-416a-97bc-7eea29f327b0',
  'ca9cc67b-94e8-4cae-92f4-882ca960d145',
  'cbcf8fb4-4471-4b64-abd6-7ecee1730b09',
  'cd25eeec-7364-4a86-b17f-0a63997ccf23',
  'cd968ec6-87e1-4875-8348-73ff9871db3e',
  'd3064e73-4829-4b05-833c-3ed1b41bdf64',
  'd9a3e8fe-f578-4577-a158-afeff7313db7',
  'e364ed4b-e58e-485e-be29-ecbffe59425d',
  'eae66dbc-8e20-4bdd-bae2-f1c5fc8c5f2e',
  'eeede33b-6794-4487-b3d7-95a17dab03cb',
  'f21c20a2-5a4e-4dc8-8e0f-e47e8e926ed6',
  'f6265ba7-df71-4590-9cf9-04fdc28f9c92',
  'fc5738fd-4582-44f7-b96a-298892787bd2',
];

const BRANCHIDS = [...PROD, ...TEST];

export const hasOldProcessFlow = (branchId?: string) => {
  if (!branchId) return false;
  return BRANCHIDS.includes(branchId);
};

const useOldProcessFlow = () => {
  const { branchId } = useParams();
  return hasOldProcessFlow(branchId);
};

export default useOldProcessFlow;
